import { VERSION } from '#src/config.ts';

export const isOutdated = (minimumFrontendVersion?: string) => {
  return (
    minimumFrontendVersion && Number(VERSION) < Number(minimumFrontendVersion)
  );
};
